import { User, UserCreate } from "rp-components"
import { apiClient } from "rp-components"
import { AuthTokens } from "rp-components"
import { Credential } from "rp-components"
import { Void } from "rp-components"

export interface AuthService {
    login(credential: Credential): Promise<Void>
    logout(): Promise<Void>
    resetPassword(credential: Credential): Promise<void>
    setPassword(credential: Credential): Promise<void>
    registerAccount(user: UserCreate): Promise<void>
    getTenants(email: string): Promise<Map<string, string>[]>
    getUser(): Promise<User>
}

class AuthServiceImpl implements AuthService {
    static instance?: AuthService = undefined

    private constructor() {}

    static getInstance(): AuthService {
        if (AuthServiceImpl.instance == undefined) {
            AuthServiceImpl.instance = new AuthServiceImpl()
        }
        return AuthServiceImpl.instance
    }

    async login(credential: Credential): Promise<Void> {
        const tokens = await apiClient.post<AuthTokens, Credential>("/login", credential, false)
        apiClient.setTokens(tokens)
        return {}
    }

    async logout(): Promise<Void> {
        await apiClient.post<Void, Void>("/admin/logout", {})
        sessionStorage.clear()
        apiClient.clearToken()
        return {}
    }

    async resetPassword(credential: Credential): Promise<void> {
        await apiClient.post<Credential, Void>("/resetPassword", credential)
    }

    async setPassword(credential: Credential): Promise<void> {
        await apiClient.post<Credential, Void>("/setPassword", credential)
    }

    async registerAccount(user: UserCreate): Promise<void> {
        await apiClient.post<UserCreate, Void>("/user", user)
    }

    async getTenants(email: string): Promise<Map<string, string>[]> {
        return await apiClient.get<Map<string, string>[]>(`/user/tenants?domain=${email}`)
    }

    async getUser(): Promise<User> {
        return await apiClient.get<User>("/user")
    }
}

export default AuthServiceImpl.getInstance()
